import Footer from "./components/Footer";
import Hero from "./components/Hero";
import HowItWorks from "./components/HowItWorks";
import Problem from "./components/Problem";
import Solution from "./components/Solution";
import Waitlist from "./components/Waitlist";

const Cura = () => {
  return (
    <div style={styles.pageWrapper}>
      <div style={styles.contentWrapper}>
        <Hero />
        <Problem />
        <Solution />
        <HowItWorks />
        <Waitlist />
        <Footer />
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  pageWrapper: {
    minHeight: "100vh",
    width: "100%",
    overflowX: "hidden",
    fontFamily: "sans-serif",
  },
  contentWrapper: {
    maxWidth: "100vw",
    width: "100%",
    margin: "0 auto",
  },
};

export default Cura;
